import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'xemex-nav-button',
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './nav-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './nav-button.component.scss',
})
export class NavButtonComponent {
  icon = input<string>('');
  label = input<string>('');
  active = input<boolean>(false);
  collapsed = input<boolean>(false);
  /** Optional count shown as a badge; hidden when 0. */
  badge = input<number>(0);
  /** Tooltip shown when hovering the badge. */
  badgeTooltip = input<string>('');
}
